import { ApiProperty } from "@nestjs/swagger";

export class MasterInfoFromIndentDto {
    @ApiProperty()
    farmerId: number;
    @ApiProperty()
    farmerCodeId: number;
    @ApiProperty()
    productId: number;
    @ApiProperty()
    assignLead1: number;
    @ApiProperty()
    assignLead2: number;
    @ApiProperty()
    indentBy:number

    /**
     * 
     * @param farmerId 
     * @param farmerCodeId 
     * @param productId 
     * @param assignLead1 
     * @param assignLead2 
     */
    constructor(farmerId:number,farmerCodeId:number,productId:number,assignLead1:number,assignLead2:number,indentBy?:number){
        this.farmerId = farmerId;
        this.farmerCodeId = farmerCodeId;
        this.productId = productId;
        this.assignLead1 = assignLead1;
        this.assignLead2 = assignLead2;
        this.indentBy = indentBy;
    }
}